import {
  TENANTREGISTER_REGISTER_REQUEST,
  TENANTREGISTER_REGISTER_SUCCESS,
  TENANTREGISTER_REGISTER_FAIL,
  TENANTREGISTER_REGISTER_RESET,
  TENANTREGISTER_RESEND_VERIFICATION_EMAIL_REQUEST,
  TENANTREGISTER_RESEND_VERIFICATION_EMAIL_SUCCESS,
  TENANTREGISTER_RESEND_VERIFICATION_EMAIL_FAIL,
  TENANTREGISTER_RESEND_VERIFICATION_EMAIL_RESET,
  TENANTREGISTER_VERIFY_EMAIL_BYCODE_REQUEST,
  TENANTREGISTER_VERIFY_EMAIL_BYCODE_SUCCESS,
  TENANTREGISTER_VERIFY_EMAIL_BYCODE_FAIL,
  TENANTREGISTER_VERIFY_EMAIL_BYCODE_RESET,
  TENANTREGISTER_REGISTER_GOOGLE_REQUEST,
  TENANTREGISTER_REGISTER_GOOGLE_SUCCESS,
  TENANTREGISTER_REGISTER_GOOGLE_FAIL,
  TENANTREGISTER_REGISTER_GOOGLE_RESET,
  TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_SUCCESS,
  TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_REQUEST,
  TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_FAIL,
  TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_RESET,
} from "../constants/tenantRegisterConstants";

export const tenantRegisterRegisterReducer = (
  state = { loading: false, success: false, tenantInfo: null, error: null },
  action
) => {
  switch (action.type) {
    case TENANTREGISTER_REGISTER_REQUEST:
      return { ...state, loading: true, error: null };
    case TENANTREGISTER_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case TENANTREGISTER_REGISTER_FAIL:
      return { ...state, loading: false, error: action.payload };
    case TENANTREGISTER_REGISTER_RESET:
      return { loading: false, success: false, tenantInfo: null, error: null };
    default:
      return state;
  }
};

export const tenantRegisterVerifyEmailByCodeReducer = (
  state = { loading: false, success: false, token: null, error: null },
  action
) => {
  switch (action.type) {
    case TENANTREGISTER_VERIFY_EMAIL_BYCODE_REQUEST:
      return { ...state, loading: true, error: null };
    case TENANTREGISTER_VERIFY_EMAIL_BYCODE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        token: action.payload.token,
        tenantID: action.payload.tenantID,
        role: action.payload.role,
      };
    case TENANTREGISTER_VERIFY_EMAIL_BYCODE_FAIL:
      return { ...state, loading: false, error: action.payload };
    case TENANTREGISTER_VERIFY_EMAIL_BYCODE_RESET:
      return { loading: false, success: false, token: null, error: null };
    default:
      return state;
  }
};

export const tenantRegisterRegisterGoogleReducer = (
  state = { loading: false, success: false, tenantInfo: null, error: null },
  action
) => {
  switch (action.type) {
    case TENANTREGISTER_REGISTER_GOOGLE_REQUEST:
      return { ...state, loading: true, error: null };
    case TENANTREGISTER_REGISTER_GOOGLE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case TENANTREGISTER_REGISTER_GOOGLE_FAIL:
      return { ...state, loading: false, error: action.payload };
    case TENANTREGISTER_REGISTER_GOOGLE_RESET:
      return { loading: false, success: false, tenantInfo: null, error: null };
    default:
      return state;
  }
};

export const tenantRegisterResendVerificationEmailReducer = (
  state = { loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case TENANTREGISTER_RESEND_VERIFICATION_EMAIL_REQUEST:
      return { ...state, loading: true, error: null };
    case TENANTREGISTER_RESEND_VERIFICATION_EMAIL_SUCCESS:
      return { ...state, loading: false, success: true };
    case TENANTREGISTER_RESEND_VERIFICATION_EMAIL_FAIL:
      return { ...state, loading: false, error: action.payload };
    case TENANTREGISTER_RESEND_VERIFICATION_EMAIL_RESET:
      return { loading: false, success: false, error: null };
    default:
      return state;
  }
};

export const tenantRegisterVerifyEmailByTokenReducer = (
  state = { loading: false, success: false, token: null, error: null },
  action
) => {
  switch (action.type) {
    case TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_REQUEST:
      return { ...state, loading: true, error: null };
    case TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        token: action.payload.token,
        tenantID: action.payload.tenantID,
        role: action.payload.role,
      };
    case TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_FAIL:
      return { ...state, loading: false, error: action.payload };
    case TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_RESET:
      return { loading: false, success: false, token: null, error: null };
    default:
      return state;
  }
};
